export { default } from "./designAdapter";
